module.exports = __webpack_public_path__ + "img/Skirt-Back-B6-Da-Fc-Gb-Hc.1f6a60b9.png";